import {  postAddBank } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_AddBankThunk = createAsyncThunk(
  "reKyc_AddBankThunk",
  async ({ params, token }) => {
    try {
      const response = postAddBank(params, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
